import * as React from 'react';
import { styles } from './styles';
interface Props {
  currentYear: number;
  handleYearSelection: (e: any) => any;
}

class YearSelector extends React.Component<Props, {}> {
  private currentYearRef = React.createRef<HTMLDivElement>();

  componentDidMount() {
    if (this.currentYearRef.current) {
      this.currentYearRef.current.scrollIntoView({ block: 'center' });
    }
  }

  buildYearItem = (year: number, isCurrentYear: boolean) => {
    return (
      <div
        ref={el => {
          if (isCurrentYear && el) {
            this.currentYearRef = React.createRef();
          }
        }}
        key={year}
        data-year={year}
        className={styles.yearItemRules(isCurrentYear)}
      >
        <span>{year}</span>
      </div>
    );
  };
  render() {
    const { currentYear, handleYearSelection } = this.props;

    let start = new Date().getFullYear() - 10;
    const end = start + 60;

    const yearsItems: React.ReactNode[] = [];
    for (; start < end; start++) {
      yearsItems.push(this.buildYearItem(start, start === currentYear));
    }

    return (
      <div onClick={handleYearSelection} className={styles.containerRules}>
        {yearsItems}
      </div>
    );
  }
}

export { YearSelector };
